import { render, staticRenderFns } from "./CmgLeaveRewardsModal.vue?vue&type=template&id=24c4a568&scoped=true&lang=pug"
import script from "./cmg-leave-rewards-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leave-rewards-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaveRewardsModal.vue?vue&type=style&index=0&id=24c4a568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4a568",
  null
  
)

export default component.exports